
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAlertFrame as ObcAlertFrameElement} from '@oicl/openbridge-webcomponents/dist/components/alert-frame/alert-frame.js';
 
 
 

 
 export const ObcAlertFrame = createComponent({
   react: React,
   tagName: 'obc-alert-frame',
   elementClass: ObcAlertFrameElement,
   events: {
     
   }
  });
 
 